import React, { FC } from 'react';
import { Accordion, BaseLevels, Text, TextWeight } from '@kb-front/ui-kit';
import { FaqItem } from 'shared/model';
import { translate } from 'shared/utils/translation';

import './index.scss';

const Faq: FC = () => {
  const faqData = (translate('usefulToKnow.faqData') || []) as FaqItem[];
  return (
    <div>
      {faqData?.map((item, i) => (
        <div className="faq__item" key={item.title + i}>
          <Accordion
            id={`faq-item-${i}`}
            hasBorderBottom={false}
            title={
              <h3>
                <Text level={BaseLevels.L2} weight={TextWeight.MEDIUM}>
                  {item.title}
                </Text>
              </h3>
            }
          >
            <p>
              <Text level={BaseLevels.L2} weight={TextWeight.MEDIUM}>
                {item.description}
              </Text>
            </p>
          </Accordion>
        </div>
      ))}
    </div>
  );
};
export default Faq;
